module.exports = require("crypto-hash");